import { CircularProgress } from "@mui/material";
import React from "react";
import "./PosCustomIcon.css";

/**
 * PosCustomIcon
 *
 * A flexible icon wrapper for POS and e-commerce UIs. Supports rendering a React icon, an image, or a loading spinner.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.icon] - The icon component to render.
 * @param {boolean} [props.loading=false] - If true, shows a loading spinner.
 * @param {string|number} [props.loaderSize=20] - Size of the loading spinner.
 * @param {string} [props.color="black"] - Icon or spinner color.
 * @param {string} [props.image] - Image URL to render instead of an icon.
 * @param {string|number} [props.height] - Height of the icon/image.
 * @param {string|number} [props.width] - Width of the icon/image.
 * @param {function} [props.onClickFunction] - Click handler for the icon.
 * @param {boolean} [props.pointer=false] - If true, cursor becomes pointer on hover.
 * @returns {JSX.Element}
 *
 * @example
 * // Render a Icon Library as Icon
 * <PosCustomIcon
 *   icon={<PlusIcon/>}
 *   loading={true}
 *   loaderSize={"16px"}
 *   color="blue"
 *   height={"12px"}
 *   widht={"12px"}
 *   onClickFunction={handleClick}
 *   pointer={false}
 * />
 *
 * @example
 * // Render a custom image as icon
 * <PosCustomIcon
 *   loading={true}
 *   loaderSize={"16px"}
 *   color="blue"
 *   image={img}
 *   height={"12px"}
 *   widht={"12px"}
 *   onClickFunction={handleClick}
 *   pointer={false}
 * />
 */

const PosCustomIcon = ({
  icon,
  loading,
  loaderSize,
  color = "black",
  image,
  height,
  width,
  onClickFunction,
  pointer,
  marginTop,
}) => {
  return (
    <div
      style={{
        color: color,
        height: height,
        width: width,
        marginTop: marginTop,
      }}
      onClick={onClickFunction}
      className={`custom-pos-icon-container ${pointer && "pointer"}`}
    >
      {loading ? (
        <CircularProgress size={loaderSize || 20} sx={{ color: color }} />
      ) : image ? (
        <img
          src={image}
          alt="custom-icon"
          style={{
            height: `${height || "100%"}`,
            width: `${width || "100%"}`,
            objectFit: "contain",
          }}
        />
      ) : (
        icon
      )}
    </div>
  );
};

export default PosCustomIcon;
